import React from 'react'
import { Row, Col, Collapse, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames'
import styled from 'styled-components'
import Modal from 'react-modal';

const Carousel = styled.div`
    display:flex;
    flex-wrap: wrap;
    margin:20px 0px;
    align-content: center;
    justify-content: center;
    align-items: flex-start;
    flex: 1 0 200px;
`;

const ThumbTitle = styled.p`
    text-align:center;
    font-size:11px;
    margin:0px;
    padding:5px 10px;
    line-height:1.5em;
    background-color: #bbb;
    color: #000;
    font-weight: bold;
    position:absolute;
    bottom:0px;
    width:100%;
`;
const ThumbLink = styled.a`
    cursor:pointer;
    width:275px;
    height:200px;
    margin:10px;
    background: url('${props => props.bImg ? props.bImg : ""}') no-repeat center;
    position:relative;
    border:1px solid #bbb;
    background-size:cover;
    &:hover ${ThumbTitle} {
        background-color:#eee
      }
`;
const CloseBtn = styled.button`
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border:solid 1px #000;
    position: absolute;
    top:5px;
    right:5px;
    font-family: Roboto, sans-serif;
    font-size:1.2em;
    font-weight:bold;
    cursor: pointer;
    opacity: 1;
    z-index: 3;
    color:#fff;
    transition: all 0.5s ease;
    background-color: #333;
    &:hover{
        background-color: #666;
    }
`;
const ModalTitle = styled.p`
margin:0px;
`;

class WhatWeDo extends React.Component {
    constructor(props) {
        super(props);
            this.toggleCollapse = this.toggleCollapse.bind(this)
            this.toggleTab = this.toggleTab.bind(this)
            this.state = {
                collapse: false,
                activeTab: '1',
                modalIsOpen: false,
                videoId: ''
            }

            console.log("this.props.intro")
            console.log(this.props)

        }
        toggleCollapse() {
            this.setState({ collapse: !this.state.collapse })
        }

        toggleTab(tab) {
            if (this.state.activeTab !== tab) {
              this.setState({
                activeTab: tab
              });
            }
        }
        OpenModal = (videoId) => {
            this.setState({ modalIsOpen: true, videoId: videoId });
          };
        
        closeModal = () => {
        this.setState({ modalIsOpen: false });
        };

    render() {
        return(
            <div>
                <Modal style={{
                            overlay: {backgroundColor: 'rgba(255, 255, 255, 0.5)'},
                            content: {position: 'absolute',top: '25%',left: '25%', right: '25%',bottom: '25%',border: '1px solid #000', background: '#000',overflow: 'auto',width: '100%',maxWidth: '600px',height: '100%',maxHeight: '415px',WebkitOverflowScrolling: 'touch',borderRadius: '10px',outline: 'none',padding: '45px', display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center'}
                        }} 
                        isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} videoId={this.state.videoId} >
                    <CloseBtn onClick={this.closeModal}>X</CloseBtn>
                    {(this.state.videoId.lastIndexOf("SPOTIFY", 0) === 0)
                        ? <iframe className="iframe-no-border" width="100%" height="232" src={`https://open.spotify.com/embed-podcast/episode/2sHRTNgEeWQjZehhAnqEcA`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        : <iframe className="iframe-no-border" width="100%" height="315" src={`https://www.youtube.com/embed/${this.state.videoId}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    }
                </Modal>
                <Row>
                    <Col md="12" className="slidingPanelIntro" dangerouslySetInnerHTML={{__html:this.props.intro}} />
                </Row>
                    <Carousel>
                        {this.props.youTubeVideos.map((video) => {
                            if(video.value.lastIndexOf("SPOTIFY", 0) === 0)
                                return <ThumbLink bImg={`https://i.scdn.co/image/ab67656300005f1ff497896c065e2b0f6c030166`} key={video.id} className="video-link" onClick={() => this.OpenModal(video.value)}>
                                            <ThumbTitle>{video.key}</ThumbTitle>
                                        </ThumbLink>
                                return <ThumbLink bImg={`https://i.ytimg.com/vi/${video.value}/hqdefault.jpg`} key={video.id} className="video-link" onClick={() => this.OpenModal(video.value)}>
                                            <ThumbTitle>{video.key}</ThumbTitle>
                                        </ThumbLink>
                            }
                        )}
                    </Carousel>
                <Row>
                    <Col md="12" className="slidingPanelLeft">
                        <div className={`collapseTrigger ${this.state.collapse ? 'open' : 'closed'}`} onClick={this.toggleCollapse}>
                            <div className="chevron" />
                            The Foundation's Through The Gates Programme
                        </div>
                        <Collapse isOpen={this.state.collapse}>
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '1' })}
                                        onClick={() => { this.toggleTab('1'); }}
                                    >
                                        About the programme
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '2' })}
                                        onClick={() => { this.toggleTab('2'); }}
                                    >
                                        Success stories
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="1">
                                    <Row>
                                        <Col xs="12">
                                            <div className="collapseContent" dangerouslySetInnerHTML={{__html:this.props.leftCol}} />
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                    <Row>
                                        <Col xs="12">
                                            <div className="collapseContent" dangerouslySetInnerHTML={{__html:this.props.rightCol}} />
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </Collapse>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default WhatWeDo



// WEBPACK FOOTER //
// ./src/components/what-we-do.js